import { useTranslation } from "react-i18next"
import { EAwardApplyTargetType } from "../../Enum/EAwardApplyTargetType"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useSnackbar } from "../../context/snackbarContext"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"

export interface ApplyAwardRequest {
  targetType: EAwardApplyTargetType
  customerIds: number[]
}

export const useApplyAward = () => {
  const { t } = useTranslation(["general", "awards"])

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { showSnackbar } = useSnackbar()

  const handleApplyAward = async (awardId: number, request: ApplyAwardRequest, onSuccess?: () => void) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.AWARD.APPLY}/${awardId}`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("awards:snackbar_association_updated_title"),
          description: t("awards:snackbar_association_updated_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  const handleRemoveAwardApply = async (awardId: number, request: ApplyAwardRequest, onSuccess?: () => void) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.AWARD.APPLY_REMOVE}/${awardId}/remove`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("awards:snackbar_association_removed_title"),
          description: t("awards:snackbar_association_removed_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { handleApplyAward, handleRemoveAwardApply }
}
